<template>
  <Modal v-model="open" :title="title" width="480">
    <Form ref="formItem" :model="formItem" :label-width="88" :rules="ruleValidate">
      <FormItem label="分类名称" prop="name">
        <Input v-model="formItem.name" placeholder="如：热菜、饮品" clearable maxlength="32" />
      </FormItem>
      <FormItem label="排序" prop="sort">
        <InputNumber v-model="formItem.sort" :min="0" :max="9999" style="width: 100%" />
        <div class="field-help">数字越小越靠前，小程序左侧分类按此排序</div>
      </FormItem>
      <FormItem label="状态" prop="status">
        <RadioGroup v-model="formItem.status">
          <Radio label="up">展示</Radio>
          <Radio label="down">隐藏</Radio>
        </RadioGroup>
        <div class="field-help">隐藏后小程序点餐页不显示该分类</div>
      </FormItem>
    </Form>
    <div slot="footer">
      <Button @click="cancel">取消</Button>
      <Button type="primary" :loading="loading" @click="submit">保存</Button>
    </div>
  </Modal>
</template>

<script>
import { foodTypeAdd, foodTypeUpdate } from '@/api/foodType'

export default {
  name: 'FoodTypeAddUpdate',
  data() {
    return {
      open: false,
      title: '添加分类',
      loading: false,
      formItem: {
        type_id: null,
        name: '',
        sort: 0,
        status: 'up',
      },
      ruleValidate: {
        name: [{ required: true, message: '请输入分类名称', trigger: 'blur' }],
      },
    }
  },
  methods: {
    init(row) {
      if (row) {
        this.title = '编辑分类'
        const tid = row.type_id != null ? row.type_id : row.typeid
        this.formItem = {
          type_id: tid,
          name: row.name || '',
          sort: Number.isFinite(Number(row.sort)) ? Number(row.sort) : 0,
          status: row.status === 'down' ? 'down' : 'up',
        }
      } else {
        this.title = '添加分类'
        this.formItem = { type_id: null, name: '', sort: 0, status: 'up' }
      }
      this.open = true
      this.$nextTick(() => {
        if (this.$refs.formItem) this.$refs.formItem.resetFields()
        if (row) {
          this.formItem.type_id = row.type_id != null ? row.type_id : row.typeid
          this.formItem.name = row.name || ''
          this.formItem.sort = Number.isFinite(Number(row.sort)) ? Number(row.sort) : 0
          this.formItem.status = row.status === 'down' ? 'down' : 'up'
        }
      })
    },
    cancel() {
      this.open = false
      this.loading = false
    },
    submit() {
      this.$refs.formItem.validate((valid) => {
        if (!valid) return
        this.loading = true
        const payload = {
          name: String(this.formItem.name || '').trim(),
          sort: Number(this.formItem.sort) || 0,
          status: this.formItem.status === 'down' ? 'down' : 'up',
        }
        const req =
          this.formItem.type_id != null
            ? foodTypeUpdate({ ...payload, type_id: this.formItem.type_id })
            : foodTypeAdd(payload)
        req
          .then((res) => {
            if (res.data && res.data.code === 200) {
              this.$Message.success(res.data.msg || '保存成功')
              this.cancel()
              this.$emit('reload')
            } else {
              this.$Message.error((res.data && res.data.msg) || '保存失败')
            }
          })
          .catch((err) => {
            this.$Message.error(err.message || '保存失败')
          })
          .finally(() => {
            this.loading = false
          })
      })
    },
  },
}
</script>

<style scoped>
.field-help {
  color: #999;
  font-size: 12px;
  margin-top: 6px;
  line-height: 1.5;
}
</style>
